import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import QuickExit from "@/components/site/QuickExit";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import ReproCoercion from "@/components/site/ReproCoercion";
import ReassuranceMarquee from "@/components/site/ReassuranceMarquee";
import Manifesto from "@/components/site/Manifesto";
import SafetyGuide from "@/components/site/SafetyGuide";
import Founder from "@/components/site/Founder";
import VideoFeature from "@/components/site/VideoFeature";
import Story from "@/components/site/Story";
import Statistics from "@/components/site/Statistics";
import Hotlines from "@/components/site/Hotlines";
import Directory from "@/components/site/Directory";
import Footer from "@/components/site/Footer";

function App() {
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;

    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    // Smooth anchor scrolling
    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id.length < 2) return;
      const el = document.querySelector(id);
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -70 });
      }
    };
    document.addEventListener("click", onClick);

    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App grain min-h-screen bg-bone">
      <QuickExit />
      <Navbar />
      <main>
        <Hero />
        <ReassuranceMarquee />
        <ReproCoercion />
        <Manifesto />
        <Founder />
        <Story />
        <VideoFeature />
        <Statistics />
        <SafetyGuide />
        <Hotlines />
        <Directory />
      </main>
      <Footer />
    </div>
  );
}

export default App;
